import { render, staticRenderFns } from "./orderStatistic.vue?vue&type=template&id=ba987d52&scoped=true"
import script from "./orderStatistic.vue?vue&type=script&lang=js"
export * from "./orderStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba987d52",
  null
  
)

export default component.exports